import type { Extra, ExtrasOrdersQuery } from '@/gql/myomr'

type ExtrasOrderNode = ExtrasOrdersQuery['extrasOrders']['nodes'][number]
type ExtrasOrderRawItem = ExtrasOrderNode['extras'][number]

type EditorExtra = Extra | ExtrasOrderRawItem

export const getEditableSnapshotCount = (item?: EditorExtra) => {
  if (!item) return 0
  if (item.priceSnapshots.length <= 1) return item.count
  return item.priceSnapshots.filter((snapshot) => snapshot.editable).reduce((sum, snapshot) => sum + snapshot.count, 0)
}

export const getLockedSnapshotCount = (item?: EditorExtra) => {
  if (!item) return 0
  if (item.priceSnapshots.length <= 1) return 0
  return item.priceSnapshots.filter((snapshot) => !snapshot.editable).reduce((sum, snapshot) => sum + snapshot.count, 0)
}

export const buildEditorOrderData = <T extends EditorExtra>(item?: T) => {
  if (!item) return undefined

  if (item.priceSnapshots.length <= 1) {
    return {
      ...item,
      count: item.priceSnapshots[0]?.count ?? item.count,
    }
  }

  return {
    ...item,
    count: getEditableSnapshotCount(item),
  }
}
